// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDafltVmWMg-ihlhJ2cvsZZ9A-HNHLqdKg",
  authDomain: "gestor-de-respuestas-hingenia.firebaseapp.com",
  projectId: "gestor-de-respuestas-hingenia",
  storageBucket: "gestor-de-respuestas-hingenia.firebasestorage.app",
  messagingSenderId: "44839617041",
  appId: "1:44839617041:web:5261bff31629f412e167b0",
  measurementId: "G-F2NYBZV6TJ"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const appId = 'gestor-respuestas-pro';

// Firebase Cloud Messaging
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.log('FCM not supported in this browser');
}
export { messaging, getToken, onMessage };

export default app;
